import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employeeprofile',
  templateUrl: './employeeprofile.component.html',
  styleUrls: ['./employeeprofile.component.scss']
})
export class EmployeeprofileComponent implements OnInit {
public pageHeight: number;
  constructor() {

    window.addEventListener('load', (event) => {
      this.pageHeight = (window.innerHeight) - 60;

     });

  }

  ngOnInit(): void {
  }


}

